import { useQuery } from "@tanstack/react-query";
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "../lib/api.js";
import { Card, Kpi, PageHeader, Spinner, brl } from "../components/ui.js";

export function Dashboard() {
  const kpis = useQuery({ queryKey: ["kpis"], queryFn: async () => (await api.get("/insights/dashboard")).data });
  const tend = useQuery({ queryKey: ["tendencias"], queryFn: async () => (await api.get("/insights/tendencias")).data as Record<string, unknown>[] });
  const frete = useQuery({ queryKey: ["insight-frete"], queryFn: async () => (await api.get("/insights/frete")).data as Record<string, unknown>[] });

  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Visão geral da operação Brasil Novo" />

      {kpis.isLoading ? <Spinner /> : (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <Kpi label="Viagens (VEGA)" value={kpis.data?.viagens ?? "—"} />
          <Kpi label="Frete acumulado" value={brl(kpis.data?.freteTotal)} />
          <Kpi label="Compliance vencida" value={kpis.data?.complianceVencida ?? "—"} hint="curso/exame vencidos" />
          <Kpi label="Inconsistências" value={kpis.data?.inconsistencias ?? "—"} hint="catalogadas" />
        </div>
      )}

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card>
          <h2 className="mb-4 font-semibold text-slate-800">Tendência de viagens por competência</h2>
          {tend.isLoading ? <Spinner /> : (
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={tend.data ?? []}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
                <XAxis dataKey="competencia" tickFormatter={(v) => String(v).slice(0, 7)} fontSize={11} />
                <YAxis fontSize={11} />
                <Tooltip />
                <Line type="monotone" dataKey="n_viagens" stroke="#117849" strokeWidth={2} name="viagens" />
              </LineChart>
            </ResponsiveContainer>
          )}
        </Card>

        <Card>
          <h2 className="mb-4 font-semibold text-slate-800">Frete por região (top)</h2>
          {frete.isLoading ? <Spinner /> : (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={(frete.data ?? []).slice(0, 10)}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
                <XAxis dataKey="regiao" tick={false} />
                <YAxis fontSize={11} />
                <Tooltip formatter={(v: number) => brl(v)} />
                <Bar dataKey="frete_total" fill="#e5aa36" name="frete" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </Card>
      </div>
    </div>
  );
}
